var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('special-account-info-panel',{attrs:{"data-source":_vm.cashPaymentRecord},on:{"on-refresh":() => _vm.getCashPaymentInfo(_vm.orderNo)}}),_c('deposit-info-panel',{attrs:{"initial-values":_vm.cashPaymentRecord},on:{"on-ok":() => _vm.$emit('on-ok')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }